import { Box, Button, Typography } from '@mui/material';
import { useRecoilValue } from 'recoil';
import { useEffect, useState } from 'react';
import ChevronRightIcon from '@mui/icons-material/ChevronRight';
import { useNavigate } from 'react-router-dom';
import { PageCategory } from '../../interfaces/PageCategory';
import { sharedColors, sharedStyles } from '../../utils/Style';
import { selectedPageAtom } from '../../atoms/Page';
import { AdminPage } from '../../interfaces/AdminPage';

type NavBarCategoryProps = {
  category: PageCategory;
};

export const NavBarCategory = (props: NavBarCategoryProps) => {
  const navigate = useNavigate();

  const selectedPage = useRecoilValue(selectedPageAtom);

  const [isSelected, setIsSelected] = useState(false);
  const [isExpanded, setIsExpanded] = useState(false);

  useEffect(() => {
    setIsSelected(
      props.category.pages.map((page) => page.pageType).includes(selectedPage),
    );
  }, [selectedPage]);

  useEffect(() => {
    if (isSelected) {
      setIsExpanded(true);
    }
  }, [isSelected]);

  const navigateToPage = (page: AdminPage) => {
    navigate(`/${props.category.path}/${page.path}`);
  };

  const handleCategoryClick = () => {
    if (props.category.pages.length === 1) {
      navigateToPage(props.category.pages[0]);
    } else {
      setIsExpanded((x) => !x);
    }
  };

  return (
    <Box
      sx={{
        display: 'flex',
        flexDirection: 'column',
        alignItems: 'stretch',
      }}
    >
      <Button
        onClick={handleCategoryClick}
        startIcon={props.category.icon}
        endIcon={
          props.category.pages.length > 1 && (
            <ChevronRightIcon
              sx={isExpanded ? { transform: 'rotate(90deg)' } : {}}
            />
          )
        }
        sx={{
          ...sharedStyles.buttonText,
          width: '100%',
          justifyContent: 'flex-start',
          py: 1.5,
          px: 2,
          gap: 1,
          color: isSelected ? sharedColors.white : sharedColors.gray2,
          backgroundColor: isSelected ? '#171d2d' : '#272f3e',
          '&:hover': {
            backgroundColor: '#1f2636',
          },
        }}
      >
        <Typography
          sx={{ flexGrow: 1, justifyContent: 'start', textAlign: 'start' }}
        >
          {props.category.name}
        </Typography>
      </Button>
      {isExpanded &&
        props.category.pages.length > 1 &&
        props.category.pages.map((page) => (
          <Button
            onClick={() => navigateToPage(page)}
            sx={{
              ...sharedStyles.buttonText,
              width: '100%',
              justifyContent: 'flex-start',
              py: 1,
              pl: 6,
              color:
                selectedPage === page.pageType
                  ? sharedColors.white
                  : sharedColors.gray2,
              backgroundColor:
                selectedPage === page.pageType ? '#171d2d' : '#272f3e',
              '&:hover': {
                backgroundColor: '#1f2636',
              },
            }}
          >
            {page.name}
          </Button>
        ))}
    </Box>
  );
};
